import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import { DataPickerHLPure, DialogTemplatePure, Traslates } from "../../pures";
import { useState } from "react";

const DialogEditExpirationDate = (props) => {
  const { t } = useTranslation();

  const [selectedDate, setSelectedDate] = useState(null);
  const [errorDate, setErrorDate] = useState(true);
  const [maxDate, setMaxDate] = useState('')

  useEffect(() => {
    if (!props.dateLimitTypeDate) return
    let maxDatePicker = new Date(props.dateLimitTypeDate)
    setMaxDate(maxDatePicker)
  }, [props.dateLimitTypeDate])

  const validateDate = (event) => {
    let dateIsValid = props.validator.limitDateValidator(event.target.value) === "";
    setErrorDate(!dateIsValid);
    setSelectedDate(event.target.value);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    let maxDatePicker = new Date(props.limitExpirationDate)
    if (selectedDate < props.date || selectedDate > maxDatePicker) {
      setErrorDate(true);
      return
    }
    await props.onUpdateExpirationDate({ expirationDate: selectedDate });
  }

  const dialogDescription = <p>
    {t("dialogEditExpirationDate.youOnlyChangeTheDatiIn60days")}
    <br />
    {t("dialogEditExpirationDate.limitDateAllow")}:{" "}
    <span
      style={{ fontWeight: 600 }}
    >
      {props.limitExpirationDate}
    </span>
  </p>

  return (
    <div>
      {/* Dialog modal to edit the expiration date of a sign request */}
      {props.visibleExpirationDate && (
        <DialogTemplatePure
          title={t("dialogEditExpirationDate.titleDialog")}
          description={dialogDescription}
          canelBtn={t("dialogEditExpirationDate.buttonCancel")}
          cancel={props.toggleEditExpirationDate}
          saveBtn={t("dialogEditExpirationDate.buttonUpdateDate")}
          handleSubmitProfile={handleSubmit}
          loadingComponent={props.showLoadingRequesting}
          saveError={props.showErrorRequesting}
        >
          <Grid container xs={12} lg={12} md={12} sm={12} es={12} style={{ height: '290px' }}>
            <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
              <Traslates>
                <DataPickerHLPure
                  labelDataPicker={t("dialogEditExpirationDate.labelNewLimitDate")}
                  limitDate={props.date}
                  handleChangeDate={validateDate}
                  maxDate={maxDate}
                />
                {
                  errorDate && selectedDate &&
                  <p style={{ fontSize: "12px" }}>{"La nueva fecha propuesta no puede ser mayor a 60 días a partir de la fecha de solicitud de firma y no puede ser menor a la ya establecida en la solicitud."}</p>
                }
              </Traslates>
            </Grid>
          </Grid>
        </DialogTemplatePure>
      )}
    </div>
  );
};
export { DialogEditExpirationDate as default };
